import {TBadgeColor} from 'src/components';
import {TSubject} from 'src/constants';

export enum EStatus {
  DRAFT = 'DRAFT',
  CREATE_SUBJECT = 'CREATE_SUBJECT',
  CREATE_SUBJECT_ERROR = 'CREATE_SUBJECT_ERROR',
  IN_PROGRESS = 'IN_PROGRESS',
  CANCELLED = 'CANCELLED',
  DONE = 'DONE',
}

export type TMaxBotChannel = {
  id: number;
  status: EStatus;
  name: string;
  accessToken: string;
  subjectRef?: TSubject;
};

export type TFormData = Partial<TMaxBotChannel>;

export const INITIAL_VALUES: TFormData = {
  name: '',
  accessToken: '',
};

export const statusColorHash: Record<keyof typeof EStatus, TBadgeColor> = {
  DRAFT: 'BLUE',
  IN_PROGRESS: 'YELLOW',
  CREATE_SUBJECT: 'YELLOW',
  CREATE_SUBJECT_ERROR: 'GREY',
  CANCELLED: 'GREY',
  DONE: 'GREEN',
};
